var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTitleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 30,
    viewBox: "0 0 38 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.2543 16.5119C38.1752 15.7143 38.1752 14.2857 37.2543 13.4881L27.3093 4.87556C26.014 3.75381 24 4.67392 24 6.38742L24 23.6126C24 25.3261 26.014 26.2462 27.3093 25.1244L37.2543 16.5119Z",
    fill: "#79D3F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2543 16.5119C26.1752 15.7143 26.1752 14.2857 25.2543 13.4881L15.3093 4.87556C14.014 3.75381 12 4.67392 12 6.38742L12 23.6126C12 25.3261 14.014 26.2462 15.3093 25.1244L25.2543 16.5119Z",
    fill: "#3099F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2543 16.5119C14.1752 15.7143 14.1752 14.2857 13.2543 13.4881L3.30931 4.87556C2.01402 3.75381 1.10704e-06 4.67392 1.03214e-06 6.38742L2.79203e-07 23.6126C2.04303e-07 25.3261 2.01402 26.2462 3.30931 25.1244L13.2543 16.5119Z",
    fill: "#0143E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleIcon);
export default __webpack_public_path__ + "static/media/titleIcon.51178e5c2ba2e136833c61be2436e7ad.svg";
export { ForwardRef as ReactComponent };